import api from '@/api/mintAgreements';

const state = {
  plan: null,
  agreements: [],
  current: null,
  loading: false,
  notifications: { count: 0, items: [] },
};

const getters = {
  plan: (state) => state.plan,
  agreements: (state) => state.agreements,
  pendingAgreements: (state) => state.agreements.filter((a) => a.status === 0),
  paidOrCancelledAgreements: (state) => state.agreements.filter((a) => a.status !== 0),
  current: (state) => state.current,
  loading: (state) => state.loading,
  notifications: (state) => state.notifications,
  notificationCount: (state) => (state.notifications && state.notifications.count) || 0,
};

const actions = {
  async getUpcomingPlan({ commit }, { from, to } = {}) {
    commit('setLoading', true);
    try {
      const params = {};
      if (from) params.from = from;
      if (to) params.to = to;
      const result = await api.getUpcomingPlan(params);
      commit('setPlan', result.data);
      return result.data;
    } finally {
      commit('setLoading', false);
    }
  },
  async getList({ commit }, filters = {}) {
    commit('setLoading', true);
    try {
      const result = await api.getList(filters);
      commit('setAgreements', result.data);
      return result.data;
    } finally {
      commit('setLoading', false);
    }
  },
  async get({ commit }, id) {
    const result = await api.get(id);
    commit('setCurrent', result.data);
    return result.data;
  },
  async createAgreement({ commit }, payload) {
    const result = await api.create(payload);
    commit('addAgreement', result.data);
    return result.data;
  },
  async updateAgreement({ commit }, { id, payload }) {
    const result = await api.update(id, payload);
    commit('updateAgreement', result.data);
    return result.data;
  },
  async markPaid({ commit }, { id, paidAt }) {
    const result = await api.markPaid(id, paidAt);
    commit('updateAgreement', result.data);
    return result.data;
  },
  async cancelAgreement({ commit }, id) {
    await api.cancel(id);
    commit('removeAgreement', id);
  },
  async getNotifications({ commit }, daysAhead = 1) {
    try {
      const result = await api.getNotifications(daysAhead);
      commit('setNotifications', result.data);
      return result.data;
    } catch (e) {
      commit('setNotifications', { count: 0, items: [] });
      return null;
    }
  },
};

const mutations = {
  setPlan(state, plan) {
    state.plan = plan;
  },
  setAgreements(state, agreements) {
    state.agreements = agreements;
  },
  addAgreement(state, agreement) {
    state.agreements.unshift(agreement);
  },
  updateAgreement(state, agreement) {
    const index = state.agreements.findIndex((a) => a.id === agreement.id);
    if (index !== -1) state.agreements.splice(index, 1, agreement);
  },
  removeAgreement(state, id) {
    const index = state.agreements.findIndex((a) => a.id === id);
    if (index !== -1) state.agreements.splice(index, 1);
  },
  setCurrent(state, current) {
    state.current = current;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setNotifications(state, payload) {
    state.notifications = payload || { count: 0, items: [] };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
